// react
import { ReactNode } from 'react';

// material
import { Box, Grid } from '@mui/material';

// ui
import { IconCircle, IconCircleProps } from '../IconCircle/IconCircle';
import { Time } from '../Time/Time';
import { Activity } from '../../../@types';
import { UserAvatarModified } from '../UserAvatarModified/UserAvatarModified';

// props
export interface LineItemProps {
	activity?: Activity;
	content: ReactNode;
	date?: Date;
	IconCircleProps?: IconCircleProps;
	isAlt?: boolean;
	title?: string;
	to?: string;
	type?: IconCircleProps['type'];
}

export const LineItem = ({
	activity,
	content,
	date,
	IconCircleProps,
	isAlt = false,
	title,
	type,
}: LineItemProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					backgroundColor: isAlt ? theme.palette.brand.grey[100] : 'transparent',
					padding: theme.spacing(2),
				};
			}}>
			<Grid alignItems="center" container justifyContent="space-between" spacing={2}>
				<Grid item flex={1}>
					<Grid alignItems="center" container spacing={1}>
						<Grid item>
							<IconCircle type={type} {...IconCircleProps} />
						</Grid>
						<Grid item flex={1}>
							{content}
						</Grid>
					</Grid>
				</Grid>

				{date && (
					<Grid item>
						{activity ? (
							<UserAvatarModified activity={activity} variant="compact" />
						) : (
							<Time date={date} TypographyProps={{ variant: 'caption' }} />
						)}
					</Grid>
				)}
			</Grid>
		</Box>
	);
};
